<template>
<Layout>
    <div class="confirmation">
        <div class="confirmation__wrapper" v-if="order">
            <div class="confirmation__wrapper-message">
                <h3>Thank you for your purchase, {{ order.customer.firstname }} {{ order.customer.lastname }}!</h3>
                <h4 class="confirmation__wrapper-reference">
                    <span>Order ref:</span> {{ order.customer_reference }}
                </h4>
            </div>
            <button class="confirmation__wrapper-back" type="button" @click="backToHome">
                <font-awesome-icon size="1x" icon="arrow-left" color="#292B83" />
                <span>Back to home</span>
            </button>
        </div>
    </div>
</Layout>
</template>

<script>
import {
    library
} from '@fortawesome/fontawesome-svg-core';
import {
    faArrowLeft
} from '@fortawesome/free-solid-svg-icons';

library.add(faArrowLeft);
import Layout from '../components/Layout.vue';

export default {
    name: 'Confirmation',
    components: {
        Layout
    },
    methods: {
        backToHome() {
            this.$router.push('/shop');
            this.$emit('back-to-home');
        }
    },
    computed: {
        order() {
            return this.$store.getters['app/order'] || null;
        },
    },
}
</script>

<style lang="scss">
.confirmation {
    &__wrapper {
        @apply text-center border-2 bg-white w-1/2 p-8 m-auto mt-20;
    }

    &__wrapper-message {
        h4 {
            @apply mt-1;
        }

        span {
            @apply font-bold;
        }
    }

    &__wrapper-back {
        @apply font-bold mt-3;

        span {
            @apply pl-2;
        }
    }
}
</style>
